// removed by extract-text-webpack-plugin
module.exports = {"container":"Tag-module__container__2mhCw","text":"Tag-module__text__2-0IX","button":"Tag-module__button__tIs2R","icon":"Tag-module__icon__3VPg_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tag/Tag.module.css
// module id = 2128
// module chunks = 0